import { useState } from 'react'
import { validateFile, generateRandomId } from '../utils/documentUtils.js'

/**
 * Custom hook for handling file upload and validation
 */
export const useFileHandling = () => {
  const [files, setFiles] = useState([])
  const [dragOver, setDragOver] = useState(false)

  const processFiles = fileList => {
    return Array.from(fileList || []).map(file => {
      const validation = validateFile(file)
      file.isValidFile = validation.isValidFile
      file.error = validation.error
      file._id = generateRandomId()
      return file
    })
  }

  const handleFileUpload = e => {
    const newFiles = processFiles(e.target.files)
    setFiles(prev => [...prev, ...newFiles])
    e.target.value = null
  }

  const handleDrop = e => {
    e.preventDefault()
    setDragOver(false)
    const newFiles = processFiles(e.dataTransfer.files)
    setFiles(prev => [...prev, ...newFiles])
  }

  const removeFile = index => {
    setFiles(prev => prev.filter((_, i) => i !== index))
  }

  const clearFiles = () => {
    setFiles([])
  }

  const getValidFiles = () => {
    return files.filter(f => f.isValidFile)
  }

  return {
    files,
    dragOver,
    setDragOver,
    handleFileUpload,
    handleDrop,
    removeFile,
    clearFiles,
    getValidFiles,
  }
}
